import { IdKey } from '@alltrails/shared/types/lists';
import apiRequest from './requestBase';

export async function saveList(ids: any[]) {
  return apiRequest({
    data: { ordered_list_ids: ids },
    method: 'POST',
    url: '/api/alltrails/lists/reorder'
  });
}

export async function deleteList(id: IdKey) {
  return apiRequest({
    method: 'DELETE',
    url: `/api/alltrails/lists/${id}`
  });
}

export async function saveListItems(listId: IdKey, itemIds: IdKey[], range?: number[]) {
  return apiRequest({
    data: { ordered_list_item_ids: itemIds, item_range: range },
    method: 'PUT',
    url: `/api/alltrails/v2/lists/${listId}/reorder`
  });
}
